<form [formGroup]="form" class="g-slider-container schedule-form">
    <app-notification class="notification" [type]="toasterType.Info">
        {{ otAgentsTexts.edit_agent.info }}
    </app-notification>
    <app-form-frequency-editor [formControl]="frequencyControl" [config]="frequencyEditorConfig"></app-form-frequency-editor>
</form>